import produce from 'immer';
import { DEPOSIT_ADDRESS, DEPOSIT_REQUEST } from '../../constants/wallet/depositConstants';

const initialState = {

}

const depositReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case DEPOSIT_ADDRESS:
      break;
    case DEPOSIT_REQUEST:
      break;
    default:
      break;
  }
});

export default depositReducer;
